import styled, {createGlobalStyle, keyframes} from "styled-components";
import {HiOutlineCheck} from "react-icons/hi";
import {BsArrowRight} from "react-icons/bs";
import { NavLink } from "react-router-dom";
import bg_test from "./Images/bg_test.png";

// old font was Montserrat

const Style = createGlobalStyle`

    *, html, body {
        margin: 0;
        padding: 0;
        font-family: 'Rubik', sans-serif;
        -webkit-font-smoothing: antialiased;
    }

    body{
        background: #1A1E1F;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    ::-webkit-scrollbar {
    width: 6px;
    }

    ::-webkit-scrollbar-track {
    background: #f1f1f1; 
    }
    
    ::-webkit-scrollbar-thumb {
    background: #f0b83d; 
    }

    ::-webkit-scrollbar-thumb:hover {
    background: #555; 
    }
`;

export default Style;

export const GenericContainer = styled.div`
    max-width: ${props => (props.large ? 84 : 55)}rem;
    margin: auto;
    margin-top: ${props => props.nomargin ? '' : '6rem'};
    background-image: ${props => (props.light ? 'linear-gradient( 45deg, transparent 29%, #D9A638 29%, #D9A638 36%, transparent 34%);' : '')};
    padding: ${props => (props.large ? '4rem calc((100% - 84rem)/2)' : '4rem calc((100% - 55rem)/2)')};
    word-break: break-all;
    text-align: ${props => (props.center ? 'center' : 'right')};
    overflow: hidden;
    position: relative;
    z-index: 1;
    
    @media (max-width: 700px) {
        margin-top: 0;
        padding-top: 0;
    }

`;

export const GalleryContainer = styled(GenericContainer)`
    @media (max-width: 900px){
        display: none;
    }
`;

export const ContainerWithPic = styled.div`
    position: relative;
    height: fit-content;
    width: 100%;
    background-image: url(${bg_test});
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: contain;
    padding-bottom: 20rem;

    @media (max-width: 700px){
        padding-bottom: 0;
    }
`;

export const DetailsContainer = styled(GenericContainer)`
    padding: 4rem 0 0 ;
    margin: 0;
    max-width: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;

    @media (max-width: 1400px){
        padding: 0;
    }
`;

export const GenericLargeContainer = styled(GenericContainer)`
    max-width: 84rem;
`;

export const GenericTitle = styled.h1`
    color: rgb(255, 255, 255);
    font-size: 40pt;
    line-height: 1;
    letter-spacing: -0.025em;
    font-weight: 700;
    text-align: inherit;
    z-index: 999999;
    position: relative;
`;

export const GenericText = styled.h2`
    color: rgb(156, 163, 175);
    font-size: 1.2rem;
    line-height: 1.75;
    font-weight: 500;
    text-align: inherit;
    max-width: 50%;
    margin-top: 2rem;
    margin-bottom: 2rem;
    margin-left: auto;
    z-index: 999999;
    position: relative;
`;

export const GenericExp = styled.h3`
    font-size: 19px;
    color: #f0b83d;
    font-weight: 500;
    letter-spacing: 1px;
    margin: 0;
    text-transform: uppercase;
    text-align: inherit;
    margin: 0.5rem;
    z-index: 999999;
    position: relative;
`;

export const SmallImg = styled.img`
    width: 64px;
    height: 64px;
`;

export const EndLine = styled.div`
    text-align: center;
    &:before{
        background-image: linear-gradient(90deg,rgba(40,50,75,.2) 0,#28324b 20%,#28324b 80%,rgba(40,50,75,.2));
        content: "";
        display: inline-block;
        height: 1px;
        position: relative;
        vertical-align: middle;
        width: 30%;
        right: 0.2em;
        margin-left: -50%;
    }

    &:after{
        background-image: linear-gradient(90deg,rgba(40,50,75,.2) 0,#28324b 20%,#28324b 80%,rgba(40,50,75,.2));
        content: "";
        display: inline-block;
        height: 1px;
        position: relative;
        vertical-align: middle;
        width: 30%;
        left: 0.2em;
        margin-right: -50%;
    }
`;

export const Separator = styled.div`
    width: 100%;
    height: 6rem;
`;
//todo {add top margin/padding to generic container and remove separator}

export const Ads = styled.div`
    position: relative;
    height: auto;

    @media (min-width: 900px){
        display: none;
    }
`;

export const AdsImage = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(${props => (props.img)});
    background-size: cover;
    background-position: center center;
    background-attachment: fixed;
    filter: blur(2px);
`;

export const AdsContent = styled.div`
    max-width: 88rem;
    height: 100%;
    position: relative;
    margin: auto;
    padding: 4rem 1rem;
`;

export const AdsOverlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    padding-top: 2px;
    top: -2px;
    background-image: radial-gradient(ellipse at center,rgba(24,30,45,.3) 0,#181e2d 130%);
`;

export const AdsExp = styled.h3`
    font-size: 20px;
    color: #D9DDDF;
    font-weight: 600;
    margin: 0;
    text-transform: uppercase;
`;

export const AdsTitle = styled.h1`
    font-weight: 700;
    font-size: 48px;
    display: block;
    color: #e5e5e5;
    margin-top: 10px;
    max-width: 555px;
`;

export const AdsTitleStrong = styled.strong`
    background: #f0b83d;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    font-style: oblique;
`;

export const GenericFlexContainer = styled.div`
    display: flex;
    margin: 50px;
`;

export const GenericRight = styled.div`
    height: auto;
    width: calc(60% - 5rem);
    margin-left: 5rem;
    display: flex;
    text-align: right;

    &::after{
        content: '${props => (props.index)}';
        border-radius: 50%;
        width: 40px;
        height: 36px;
        padding: 8px;
        margin-left: 1.5rem;

        font-weight: bold;
        background: #e5e5e5;
        color: #181e2d;
        text-align: center;
        font-size: 32px;
        margin-top: 5px;
    }
`;

export const AdaptableImg = styled.img`
    width: 40%;
    height: max-content;
    border-radius: 5px;
    margin-left: ${props => (props.isRight ? 1 : 0)}rem;
    margin-right: ${props => (props.isRight ? 0 : 1)}rem;
`;

export const Fit = styled.div`
    width: fit-content;
    padding: 10px;
    margin-left: 1rem;
    padding-top: 0;
`;

export const GenericLeft = styled.div`
    height: auto;
    width: calc(60% - 5rem);
    margin-right: 5rem;
    display: flex;
    text-align: left;

    &::before{
        content: '${props => (props.index)}';
        border-radius: 50%;
        width: 40px;
        height: 36px;
        padding: 8px;
    
        background: #e5e5e5;
        color: #181e2d;
        text-align: center;
        font-weight: bold;
        font-size: 32px;
        margin-top: 5px;
    }
`;



export const BoxText = styled.p`
    margin: 0 0 25px;
    color: #a8a8a8;
    font-size: 16px;
    line-height: 29px;
    text-align: inherit;
    white-space: pre-wrap;
    word-break: break-word;
`;
//todo {add carousel in ads}

export const Strong = styled.strong`
    margin-left: 5px;
    color: #f0b83d;
    display: ${props => (props.br ? 'block' : '')};
`;

//todo {add prices   and contacts}

export const ContactBtn = styled.a`
    background: #f0b83d;
    border-radius: 4px;
    color: #e5e5e5;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    padding: 16px 32px;
    margin: 30px 0 0;
    font-weight: bold;
    text-decoration: none;

    &:hover{
        opacity: 0.9;   
    }
`;

export const PriceWrapper = styled.div`
    margin: auto;
    display: flex;
`;

export const Price = styled.div`
    flex: 1;
    background: #e5e5e5;
    margin: auto;
    height: fit-content;
    padding: 2rem;
    padding-top: ${props => (props.large ? 3.5 : 2)}rem;
    padding-bottom: ${props => (props.large ? 3.5 : 2)}rem;
    border-radius: 1.5rem;
    max-width: 24rem;
    z-index: 2;
    margin: auto 1rem;
    `;

export const PriceHeader = styled.div`
    display: flex;
    padding-bottom: 1.75rem;
    margin-bottom: 1.75rem;
    align-items: center;
    border-bottom: 1px solid rgba(209,213,219);
`;

export const LeftImage = styled.img`
    width: 5rem;
    height: 5rem;
    border-radius: 1.5rem;
    max-width: 100%;
`;

export const RightContent = styled.div`
    margin-left: 1.25rem;
`;

export const ContentTitle = styled.h1`
    font-weight: 600;
    font-size: ${props => (props.large ? 2 : 1.5)}rem;
    line-height: 2rem;
    color: ${props => props.light ? '#e5e5e5' : ''};
`;

export const ContentPrice = styled.span`
    font-size: ${props => (props.large ? 2.225 : 1.875)}rem;
    line-height: 2.25rem;
    font-weight: 700;
    color: ${props => props.light ? '#e5e5e5' : ''};

    &::before{
        content: '$';
        color: rgb(107,114,128);
        font-size: 1.25rem;
        line-height: 1.75rem;
        vertical-align: top;        
        font-weight: 500;
    }

    &::after{
        content: ' / user';
        color: rgb(107,114,128);
        font-size: 1.25rem;
        line-height: 1.75rem;
        font-weight: 500;
    }
`;

export const Features = styled.ul`
    margin-bottom: 1.75rem;
    font-weight: 500;
`;

export const Feature = styled.li`
    margin-bottom: ${props => (props.large ? 1 : .5)}rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
    display: flex;
`;

export const Check = styled(HiOutlineCheck)`
    width: 28px;
    height: 24px;
`;

export const CheckText = styled.span`
    margin-left: .75rem;
    color: #6b7280;
    font-size: ${props => (props.large ? 20 : 18)}px;
`;

export const CheckTextStrong = styled.span`
    color: ${props => props.light ? '#e5e5e5' : '#000'};
`;

export const PriceButton = styled.button`
    padding: 1.25rem 1rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
    justify-content: center;
    align-items: center;
    border-radius: .75rem;
    background: #f0b83d;
    outline: none;
    border: none;
    cursor: pointer;
    color: #e5e5e5;
    width: 100%;
    font-weight: bold;
`;

export const Arrow = styled(BsArrowRight)`
    width: 18px;
    height: 18px;
    vertical-align: middle;
`;

export const ContactWrapper = styled.div`
    display: flex;
    padding: 4rem 0;
    position: relative;
    background: #0E0F13;

    @media (min-width: 900px) {
        background-image:  linear-gradient( 45deg, #181C1F 27%, #D9A638 27%, #D9A638 34%, #0D0E12 34%);
    }

    @media (max-width: 900px){
        flex-flow: column-reverse;
    }

`;

export const ContactQuoteWrapper = styled.div`
    width: 50%;
    padding: 2rem;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;

    @media (max-width: 900px){
        width: 100%;
        padding: 1.25rem;
    }
`;

export const ContactQuote = styled.div`
    max-width: ${props => (props.left ? '100%' : '30rem')};
    text-align: right;
    margin: ${props => (props.left ? '0 auto 0 0 ' : '0 0 0 auto')};
    color: #a8a8a8;
    font-size: 16px;
    line-height: 29px;
    white-space: pre-wrap;
    word-break: break-word;
    text-align: ${props => (props.left ? 'left' : 'right')};

    @media (max-width: 900px) {
        max-width: 100%;
        text-align: center;
    }
`;

export const ContactForm = styled.form`
    margin: 2rem;
    padding: 0 4rem;
    text-align: left;
    width: 100%;
    box-sizing: border-box;

    @media (min-width: 900px){
        border-left: 2px dashed #787577;
        width: calc(50% - 4rem);
    }

    @media (max-width: 900px){
        margin: 0;
        padding: 0 1.25rem;
    }
`;

export const ContactTitle = styled.h1`
    margin-bottom: 10px;
    font-size: 34pt;
    font-weight: 700;
    line-height: 50px;
    margin-bottom: 2rem;
    text-transform: uppercase;
    color: #e5e5e5;

    @media (max-width: 900px){
        text-align: center;
    }
`;

export const ContactStrong = styled.strong`
    color: rgb(240, 184, 61);
    font-weight: bold;
`;

export const ContactInput = styled.input`
    padding: 1.5rem 2rem;
    background: transparent;
    font-size: 16px;
    color: #e5e5e5;
    outline: none;
    border-radius: 1px;
    border: 2px solid #363739;
    margin-bottom: 1rem;
    width: 100%;
    display: block;
    box-sizing: border-box;
`;

export const Flex = styled.div`
    display: flex;
    justify-content: space-between;
    max-width: 30rem;
`;

export const ContactText = styled.textarea`
    padding: 1.5rem 2rem;
    background: transparent;
    font-size: 16px;
    color: #e5e5e5;
    outline: none;
    border-radius: 1px;
    border: 2px solid #363739;
    margin-bottom: 2rem;
    margin-top: 2rem;
    resize: none;
    height: 120px;
    display: block;
    width: 100%;
    display: block;
    box-sizing: border-box;
`;

export const Max = styled.div`
    max-width: 550px;
    text-align: right;

    @media (max-width: 900px){
        max-width: 100%;
    }
`;

export const ContactButton = styled.button`
    padding: 1.25rem 1rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: .75rem;
    background: transparent;
    outline: none;
    border: 3px solid rgb(240,184,61);
    cursor: pointer;
    color: rgb(240,184,61);
    width: 100%;
    max-width: 34.5rem;
    font-weight: bold;
    display: block;

    &:hover{
        color: #e5e5e5;
        background: rgb(240,184,61);
    }
`;

export const ContactChicken = styled.img`
    position: absolute;
    bottom: 0;
    left: 5rem;
    z-index: 1;
    max-width: auto;
    max-height: 80%;
    width: auto;

    @media (max-width: 1500px) {
        max-height: 60%;
    }

    @media (max-width: 1000px) {
        max-height: 50%;
    }

    @media (max-width: 900px){
        display: none;
    }
`;

//todo {add center text ads}

export const SkillSet = styled.div`
    width: 150px;
    height: 800px;
    background: #000;
`;

export const SkillTitle = styled.h1`
    color: #0D0E10;
    transform: rotate(90deg);
    transform-origin: 0 0;
`;

export const SkillOverlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
`;

export const SkillBarClipper = styled.div`
    width: 100%;
    overflow: hidden;
    height: 40px;
    display:flex;
`;

export const SkillSpan = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${props => (props.color)};
    line-height: 40px;
    text-align: center;
    font-weight: bold;
    color: #444444;
`;

export const BuildsButton = styled(NavLink)`
    background: #f0b83d;
    border-radius: 25px;
    color: #1b2233;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    padding: 16px 40px;
    margin: 30px 0 0;
    font-weight: bold;
    text-decoration: none;

    &:hover{
        opacity: 0.9;
    }
`;

export const YellowLine = styled.div`
    position: absolute;
    z-index: 0;
    transform: rotate(30deg);
    width: 80px;
    height: 150vh;
    background: linear-gradient(to bottom, rgba(240, 184, 61, 1), rgba(0, 0, 0, 0));
    left: 30%;
    top: -40%;
`;

export const BuildImg = styled.img`
    position: absolute;
    bottom: 0;
    left: 0;
    width: auto;
    max-height: 90%;
    height: auto; 
    z-index: 999;
    transform: scaleX(-1);
`;

export const NoBgButton = styled.button`
    padding: .5rem 2rem;
    background: transparent;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 28px;
    color: #DBDBDB;
    outline: none;
    border-radius: 1px;
    border: 2px solid #F0B83D;
    margin-bottom: 2rem;
    width: 100%;
    display: block;
    box-sizing: border-box;

    cursor: pointer;

    &:hover{
        background-color: #F0B83D;
        color: #fff;
    }
`;

export const FlexContainer = styled.div`
    display: flex;
    flex-flow: row;
    overflow: hidden;
    position: relative;
    width: auto;
    margin: auto;
`;

export const Box = styled.div`
    
    background-image: linear-gradient(#1B2233 70%, rgba(0,0,0,0));
    width: 100%;
    height: auto;
    padding: 4rem 4rem 4rem 2rem;
    position: relative;
    text-align: left;

    &:nth-child(2){
        background: #F0B83D;
        width: 200px;
        padding-top: calc(1rem + 60px);
        height: auto;
        margin-top: 60px;
    }

    &:first-child{
        margin-top: 100px;
        padding-top: calc(1rem + 20px);
    }

    &:last-child{
        margin-top: 20px;
        padding-top: calc(1rem + 100px);
    }
`;

export const BoxTitle = styled.h1`
    margin-bottom: 10px;
    font-size: 36px;
    font-weight: 600;
    line-height: 50px;
    color: #e5e5e5;
`;

export const BoxTitleUpper = styled.h1`
    margin-bottom: 10px;
    font-size: 22px;
    font-weight: 600;
    color: #e5e5e5;
    text-align: left;
    text-transform: uppercase;

    &:after{
        content: "";
        display: block;
        width: 30%;
        margin-top: 1rem;
        border-top: 2px dashed #F0B83D;
    }
`;

export const BoxHeader = styled.div`
    width: 100%;
    margin: 1rem;
    padding: 0 2rem;
    &:first-child{
        margin-left: 0;
        padding-left: 0;
    }

    &:last-child{
        margin-right: 0;
        padding-right: 0;
    }
`;

export const DashedLine = styled.div`
    width: 2px;
    height: auto;
    border-right: 2px dashed #e5e5e5;
    position: relative;
    &::before{
        content: "◆";
        color: #f0b83d;
        font-size: 24px;
        position: absolute;
        top: -10px;
        left: -9px;
    }

    &::after{
        content: "◆";
        color: #f0b83d;
        font-size: 24px;
        position: absolute;
        bottom: -7px;
        left: -9px;
        z-index: 0;
    }
`;

export const AbsoluteTitle = styled.h1`
    color: ${props => (props.light? '#e5e5e5' : '#F0B83D')};
    font-size: 40pt;
    font-weight: 700;
    text-align: inherit;
    text-transform: uppercase;
    display: inline-block;
    padding-right: 3rem;

    &::after{
        content: "◆";
        color: ${props => (props.light? '#F0B83D' : '#e5e5e5')};
        font-size: 24px;
        margin-top: 15px;
        margin-left: 15px;
        position: absolute;
    }

    ${props => props.hide &&
        `    
        @media (max-width: 1800px){
            display: none;
        }`
    }

    @media (max-width: 1800px){
        padding-bottom: 2rem;
        padding-right: 0;

        &::after{
            display: none;
        }
    }


`;

export const AbsoluteDiv = styled.div`

    @media (min-width: 1800px){
        position: absolute;
        bottom: 50%;
        right: -200px;
        transform: rotate(270deg);
    
        padding-bottom: 3rem;
    }
`;

export const DragonImg = styled.img`
    position: absolute;
    bottom: 10%;
    left: -3%;
    width: auto;
    max-width: 40%;
    height: auto;
    z-index: 999;
    -webkit-transform: scaleX(-1);
    -ms-transform: scaleX(-1);
    transform: scaleX(-1);
`;


export const Overlay = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    background-image: linear-gradient(to bottom, transparent 50%, #0D0E12 100%);
`;

export const ContactLine = styled.div`
    position: absolute;
    z-index: 0;
    width: 100px;
    height: 215%;
    background-image: linear-gradient(to bottom, #B08B33, #161B1F);
    transform: rotate(130deg);
    left: 20%;
    bottom:-50%;
`;

export const Details = styled.div`
    margin-top: 6rem;
    max-width: 50%;
    width: calc(50% - 240px);
    padding: 120px; 
    background: linear-gradient(to bottom right, #131416, #070709);
    margin-left: auto;
    word-break: normal;

    @media (max-width: 1400px){
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        margin-top: 0px;
    } 

    @media (max-width: 900px){
        padding: 60px;
    }

    @media (max-width: 600px){
        padding: 2rem;
    }

`;

export const DetailsTitle = styled.h1`
    font-weight: bold;
    font-size: 48px;
    text-transform: uppercase;
    color: #E7E7E8;
    text-align: ${props => props.center ? 'center' : 'left'};

    @media (max-width: 900px){
        font-size: 32px;
    }
`;

export const DetailsContent = styled.div`
    max-width: 90%;
    text-align: right;
    margin: 2rem auto 0 0;
    color: #a8a8a8;
    font-size: 16px;
    line-height: 29px;
    white-space: pre-wrap;
    word-break: break-word;
    text-align: left;

    &::after{
        content: 'You can find me here:';
        display: block;
    }
`;

export const Teams = styled.div`
    display: flex;
    padding-bottom: 2rem;
    flex-flow: wrap;
`;

export const Team = styled.img`
    max-width: 65px;
    max-height: 65px;
`;

export const TeamWrapper = styled.a`
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    color: #fff;
    text-decoration: none;
    margin-right: 1rem;
    margin-top: 1rem;
`;

export const DetailsButton = styled.a`
    padding: .8rem 2rem;
    background: transparent;
    text-transform: uppercase;
    font-size: 20px;
    color: #BCBCBC;
    outline: none;
    border-radius: 1px;
    border: 2px solid #F0B83D;
    margin-top: 2rem;
    width: fit-content;
    display: block;
    box-sizing: border-box;
    cursor: pointer;
    text-decoration: none;

    &:hover{
        background: #F0B83D;
        color: #fff;
    }
`;

export const CarImg = styled.img`
    position: absolute;
    max-width: auto;
    width: auto;
    max-height: 40%;
    bottom: -1rem;
    left: -2rem;
    z-index: 999;

    @media (max-width: 2220px){
        height: 32%
    }

    @media (max-width: 1800px){
        height:28%
    }

    @media (max-width: 1600px){
        height:25%
    }

    @media (max-width: 1500px){
        height:23%
    }

    @media (max-width: 1400px) {
        display: none;
    }
`;